export default "__VITE_ASSET__66d53520__"